import { baseUrl } from "../config/endPoints";
import keycloak from "./keycloak";

const API_KEY = process.env.REACT_APP_API_KEY;

const blobCache = new Map();

export const fetchAuthImage = async (photoId) => {
  const cacheKey = photoId;
  if (blobCache.has(cacheKey)) {
    return blobCache.get(cacheKey);
  }

  const url = `${baseUrl}arshad/image/${photoId}?api_key=${API_KEY}`;

  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
    },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch image: ${res.status}`);
  }

  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  blobCache.set(cacheKey, blobUrl);
  return blobUrl;
};

export const clearImageCache = () => {
  blobCache.forEach((url) => URL.revokeObjectURL(url));
  blobCache.clear();
};
